import atacadao from '../assets/images/markets/atacadao.png'

const markets = [
  {
    id: 1,
    name: "Atacadão",
    image: atacadao,
  },
 
];

export default markets;
